/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp,h } from 'vue';
import {createRouter,createWebHistory} from "vue-router";
import Employees from './vue/employees.vue';

const employeesAppElement = document.querySelector("#employeesApp");
if (employeesAppElement) {
    const router = createRouter({
        history: createWebHistory(),
        routes: [{path : window.location.pathname,component:Employees}]
    });

    const employeesApp = createApp({
        data(){},
        render: ()=>h(Employees)
    });

    employeesApp.use(router);
    router.isReady().then(() => employeesApp.mount(employeesAppElement));
}